import { Wrapper } from '~/components/dialogs/Wrapper'
import { Contact } from '~/components/Contact'

const contents = [
  {
    status: 'active',
    display: 'Your decision about organ donation has been registered.',
  },
  {
    status: 'pending',
    display: 'Your registration is being processed.',
  },
  {
    status: 'no-record',
    display: `
    We do not have a record of your decision about organ donation.
      <p class="my-4"><span class="font-semibold">Take two minutes</span> to <a href="/">register your decision online</a> now.</p>
      <p class="text-base">If you filled out a paper registration form, we may not have processed it yet. Please check again in a few days.</p>
        `,
    header: false,
  },
]

export const Success = ({ status }) => {
  const content = contents.find((msg) => msg.status === status)
  return (
    <Wrapper>
      <SuccessContent message={content.display} showHeader={content.header ?? true} />
    </Wrapper>
  )
}

export const SuccessContent = ({ showHeader, message, close }) => {
  return (
    <>
      {showHeader && <h4 className="pb-3 text-4xl font-semibold text-primary-green">Thank you</h4>}
      <div
        className="mb-2 pb-4 text-xl text-[#666666]"
        dangerouslySetInnerHTML={{ __html: message }}
      />
      <div className="leading-7 text-[#333333]">
        <p className="pb-4">
          If you have any questions,&nbsp;
          <Contact />
        </p>
      </div>
      <div className="float-right">
        <button
          type="button"
          className="rounded-full bg-primary-blue px-6 py-2 text-2xl text-slate-50 transition-colors duration-300 hover:bg-primary-blue/80"
          onClick={close}
        >
          Close
        </button>
      </div>
    </>
  )
}
